<template>
  <div class="companyLogin">
   <component v-bind:is="layout"></component>
    
  </div>
</template>

<script>
export default {
    name: 'companyLogin',
    components:{
        
    },
    created:function(){
      this.company_id=this.$route.params.company_id
      //console.log('comapnyidLogissssssnasasasaa-'+this.company_id)
    },
    computed: {

      layout () {
        //const themename = this.$store.state.currentTheme
        var themename='ThemeMDB'
        return () => import('@/components/'+themename+'/companyLogin')
      }
  }

};
</script>